// groupDsl.js — parse/serialize voor G-veld DSL: <base>[:sort_asc=<f>][,sort_desc=<f>]
// base = 'all' | 'pinned' | 'Field-Value' (Field uit FIELDS)

const FIELDS = ['Category', 'Prio', 'Importance', 'Stage'];
const SORT_FIELDS = ['title', 'createdOn', 'updatedOn'];

function parseGroupDsl(str) {
    const raw = (str || '').trim();
    const [basePart, sortPart] = raw.split(':');

    let baseType = 'all', field = '', fieldValue = '';
    if (basePart === 'all' || basePart === '') {
        baseType = 'all';
    } else if (basePart === 'pinned') {
        baseType = 'pinned';
    } else {
        const dashIdx = basePart.indexOf('-');
        if (dashIdx > -1) {
            baseType = 'field';
            field = basePart.slice(0, dashIdx);
            fieldValue = basePart.slice(dashIdx + 1);
        }
    }

    let sortAsc = '', sortDesc = '';
    if (sortPart) {
        sortPart.split(',').forEach((pair) => {
            const [k, v] = pair.split('=');
            if (k === 'sort_asc') sortAsc = v || '';
            if (k === 'sort_desc') sortDesc = v || '';
        });
    }

    return { baseType, field, fieldValue, sortAsc, sortDesc };
}

function serializeGroupDsl({ baseType, field, fieldValue, sortAsc, sortDesc }) {
    let base = 'all';
    if (baseType === 'pinned') base = 'pinned';
    if (baseType === 'field') base = `${field}-${fieldValue}`;

    const sortPairs = [];
    if (sortAsc) sortPairs.push(`sort_asc=${sortAsc}`);
    if (sortDesc) sortPairs.push(`sort_desc=${sortDesc}`);

    return sortPairs.length ? `${base}:${sortPairs.join(',')}` : base;
}

export { FIELDS, SORT_FIELDS, parseGroupDsl, serializeGroupDsl };
